import { Assignment } from "../models/Assignment";
import { AssignedAssessmentGroup } from "../models/AssignedAssessmentGroup";
import { AssignedAssessment } from "../models/AssignedAssessment";
import { Injectable } from "@angular/core";
import { AssignedLibraryAsset } from "../models/AssignedLibraryAsset";
import { AssignmentSingle } from "../models/AssignmentSingle";

@Injectable()
export class AssignmentHydratorService 
{

	public hydrateAssignment(record:any) : Assignment 
	{
		let assignment:Assignment;
		if (record.type == "AssessmentGroup") {
			assignment = Object.assign(new AssignedAssessmentGroup(), record) as AssignedAssessmentGroup;
			assignment.Items = record.items.map(i => {
				return Object.assign(new AssignedAssessment(), i);
			});
		}
		else {
			assignment = Object.assign(new AssignmentSingle(), record);
			let recordItem = record.items && record.items.length ? record.items[0] : {};
			let item;
			if (record.type == "Assessment") 
			{
				item = Object.assign(new AssignedAssessment(), recordItem);
			} 
			else if (record.type == "LibraryAsset") 
			{
				item = Object.assign(new AssignedLibraryAsset(), recordItem);
			}
			else {
				console.error("Failed to find valid assignment ", record);
				item = Object.assign(new AssignedAssessment(), recordItem); // default it to an assessment
			}
			assignment.Items = [item];
		}
		return assignment;
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/services/assignment-hydrator.service.ts